export function SEmbedLoadingState() {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-3 rounded-t-lg bg-white p-6 text-sm"
      style={{
        color: "oklch(0.556 0 0)",
        fontFamily: '"Geist Variable", sans-serif',
      }}
    >
      <div className="size-5 animate-spin rounded-full border-2 border-current border-b-transparent" />
      <p>Loading...</p>
    </div>
  );
}
